//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import { convertConfiguredTime } from '../../../components/helpers.js'
import { getExtendedVehicleName, formatAssignmentType, getAssignmentTypeColor } from '../../../forms/Brigade/BrigadeForkliftTruck/BrigadeForkliftTruckField.js'

import Table from '../../../components/Table/Table.vue'
import TableCellObject from '../../../components/Table/TableCellObject.vue'
import VehicleProvisionDispatcher from '../../../forms/VehicleProvision/VehicleProvisionDispatcher.vue'

export default {
  components: {
    Table,
    TableCellObject
  },
  props: {
    forkliftTruckRequests: {
      type: Array,
      default () {
        return []
      }
    },
    brigade: {
      type: Object,
      default () {
        return {}
      }
    },
    readonly: {
      type: Boolean,
      default: false
    },
    short: {
      type: Boolean,
      default: false
    },
    create: {
      type: Boolean,
      default: true
    }
  },
  data: function () {
    return {
      pagination: {
        rowsPerPage: 25,
        page: 1
      },
      getExtendedVehicleName: getExtendedVehicleName,
      formatAssignmentType: formatAssignmentType
    }
  },
  computed: {
    columns: function () {
      let columns = [
        {
          name: 'requestKey',
          label: '№',
          align: 'left',
          field: 'key',
          defaultWidth: 30
        },
        {
          name: 'vehicle',
          label: 'ТС',
          align: 'left',
          field: 'vehicle',
          format: (vehicle, forkliftTruckRequest) => {
            return this.getExtendedVehicleName(forkliftTruckRequest)
          }
        },
        {
          name: 'bpState',
          label: 'Статус заявки',
          labelTable: 'Статус</br>заявки',
          align: 'left',
          field: 'bpState',
          format: bpState => bpState ? bpState.name : null,
          headerStyle: 'white-space: pre-line !important;'
        },
        {
          name: 'assignmentType',
          label: 'Статус назначения',
          labelTable: 'Статус</br>назначения',
          align: 'left',
          field: 'assignmentType',
          format: (key, row) => this.formatAssignmentType(row, this.short),
          headerStyle: 'white-space: pre-line !important;'
        },
        {
          name: 'date',
          label: 'Интервал действия заявки',
          labelTable: 'Интервал</br>действия заявки',
          align: 'left',
          field: 'date',
          format: (date, row) => row.fromTime && row.toTime ? (`${this.convertTime(row.fromTime)} - ${this.convertTime(row.toTime)}`) : '',
          headerStyle: 'white-space: pre-line !important;'
        },
        {
          name: 'applicant',
          label: 'Заявитель',
          align: 'center',
          field: 'applicant',
          sortable: false,
          columnFormat: 'object',
          columnObjectType: 'employee'
        }
      ]

      if (this.short) {
        columns = columns.filter(column => column.name === 'vehicle' || column.name === 'assignmentType' || column.name === 'bpState')
      }

      return columns
    }
  },
  methods: {
    onOpen: function (vehicleProvision) {
      return this.openVehicleProvision(vehicleProvision, false)
    },
    onAddBrigade: function (vehicleProvision) {
      return this.openVehicleProvision(vehicleProvision, true)
    },
    openVehicleProvision: function (vehicleProvision, addBrigade = false) {
      let additionalParams = null
      const vehicleProvisionId = vehicleProvision.id
      if (addBrigade) {
        additionalParams = {}
        if (this.brigade) {
          additionalParams.brigade = {
            id: this.brigade.id,
            workDate: this.brigade.startWorkTime,
            workShift: this.brigade.workShift.key
          }
        }
      }

      this.$d.dialog(this).show({
        maximized: true,
        persistent: true,
        headerHidden: true,
        contentComponent: VehicleProvisionDispatcher,
        contentProps: {
          vehicleProvisionId: vehicleProvisionId,
          inputAdditionalParams: additionalParams,
          dialog: true
        },
        componentHandlers: {
          cancel: () => {
            this.$emit('vehicle-provision-close')
          }
        }
      })
    },
    convertTime: function (ms) {
      return convertConfiguredTime(ms, { year: false, month: true, date: true, hour: true, min: true, sec: false })
    },
    getTdStyle: function (col, row) {
      if (col.name === 'assignmentType') {
        if (row.id) {
          return this.getColoredTdStyle(getAssignmentTypeColor(row.assignmentType), 'black')
        }
      }
      if (col.name === 'bpState' && row.bpState) {
        return this.getColoredTdStyle(row.bpState.color, 'black')
      }
    },
    getColoredTdStyle: function (bgColor, color, fontWeight = 500) {
      return `font-weight: ${fontWeight} !important;
          background-color: ${bgColor} !important;
          color: ${color} !important;
          border-bottom: solid #e0e0e0 1px;`
    }
  }
}

